import React, { Component, Fragment } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import {reportReasonsFetch, addSystemMessage} from '../../../actions/index';
import Modal from 'react-modal';
import {Icon} from '../../Common/Icon';
import cx from '../../../styles';
import { gtmSend } from '../../../helpers';
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

class ReportReasonsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {isOpen: false};
    }

    customStyles = {
        content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            marginRight           : '-50%',
            transform             : 'translate(-50%, -50%)'
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(e);
        this.closeModal();
        gtmSend(`${this.props.title == 'report_user'? 'cw_user_report_submit': 'cw_report_submit'}`, `${this.props.cardName}`, `${this.props.title == 'report_user'? 'User Report Submit': 'Report Submit'}`, `${this.props.topic? `${this.props.topic.name}`:'--'}`, 0, {card_type: `${this.props.cardName}`, [this.props.cardName === 'Reply Card'?'reply_id': 'card_id']: `${this.props.id}`, topic_name: `${this.props.topic? `${this.props.topic.name}`:'--'}`, topic_id: `${this.props.topic? `${this.props.topic.id}`:'--'}`, reported_user_id: `${this.props.authorId? `${this.props.authorId}`:'--'}`, report_type: `${this.props.title == 'report_user'? 'User Report': 'Post Report'}`});
        this.props.addSystemMessage({id: Math.random(), message: 'reported!', level: 'success'});
    }

    openModal = () => {
        this.props.reportReasonsFetch(this.props.type)
        .then(() => {
            this.setState({isOpen: true});
        });
    }

    onModalOpen = () => {
        window.scrollTo(0, this.props.position);
    }

    closeModal = () => {
        this.setState({isOpen: false});
    }

    onModalClose = () => {
        this.setState({isOpen: false});
    }

    translate = (k, translator) => {
        if(k == 'report') {
            return translator('community_action_report');
        } else if(k == 'report_user') {
            return translator('community_action_report_user');
        }
    }

    render() {
        const t = this.props.t;
        return (
            <Fragment>
                <span onClick={this.openModal}>{this.translate(this.props.title, t)}</span>
                <Modal isOpen={this.state.isOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass"
                    style={this.customStyles} >

                    <div className="report-reasons-component">
                        <span className={cx("close-modal")} onClick={this.onModalClose} >
                            <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                            <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
                        </span>

                        <form onSubmit={this.onSubmit} method="post">
                            <ul>
                                {
                                    this.props.appReducer.reportReasons &&
                                    this.props.appReducer.reportReasons.map((reason, i)=>{
                                        return (
                                            <li key={i}>
                                                <div className={cx("btn-check-label")}>
                                                    <input type="radio" name="reason" value={reason.id} />
                                                    <label>{reason.reason}</label>
                                                </div>
                                            </li>
                                        );
                                    })
                                }
                            </ul>

                            <div>
                                <textarea name="comment" rows="3" />
                            </div>

                            <div>
                                <input className={cx("btn", "btn-primary")} type="submit" value={t('report_send')} />
                            </div>
                        </form>
                    </div>

                </Modal>
            </Fragment>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        reportReasonsFetch,
        addSystemMessage
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ReportReasonsComponent));
